module.exports = "/images/li.svg?df248aba2882559df18fb99b437aa5ee";